module.exports = __webpack_public_path__ + "media/images/ticket-e9e9835562a6b16b110d5794874c75e3.svg";